import React from 'react';
import styles from '../../static/css/pages.module.css';
import Title from "../../components/title/title";
import Header from "../../components/header/priv/header";
import Footer from "../../components/footer/footer";
import screenshot01 from '../../static/img/nalog/01.svg';
import screenshot02 from '../../static/img/nalog/02.svg';
import screenshot03 from '../../static/img/nalog/03.svg';
import Button from "../../components/form/button/button";
import ieSvg from "../../components/icons/ieSvg";
import PageError from "./error";
import {connect} from "react-redux";
import {getInfoAction} from "../../store/actions/getInfoAction";
import * as consts from "../../store/constants/userInfo";
import PageLoading from "../server/preload";
import ButtonCancel from "../../components/form/button/button_cancel";

class PageRequest extends React.Component {
  componentDidMount() {
    document.title = "Доступ к личному кабинету / Стать самозанятым | FBalance";
    ieSvg();
    if (this.props.data.items) return;
    this.props.fetchData(process.env.REACT_APP_GATE + "client/info", this, consts.CLIENT_INFO);
  }

  handleReload = () => {
    window.location.reload();
  }

  render() {
    if (this.props.data.items) {
      if(this.props.data.items.result.status === 'ERROR') {
        return <PageError
          infoTitle="Что-то пошло не так"
          infoMessage={this.props.data.items.result.errorMessage}
          infoLink={process.env.REACT_APP_ELF_URL}
          infoButton="Вернуться в интернет-банк"
        />;
      }
      else {
        return (
          <main>
            <Header type="pubinner"/>
            <section className={styles.section}>
              <div className="inner inner_small">
                <div className="l-grid">
                  <div className="l-grid__item_12">
                    <div className={styles.content}>
                      <div className="l-grid">
                        <div className="l-grid__item_1"/>
                        <div className="l-grid__item_10">
                          <Title icon="icon_profile" title="Доступ к личному кабинету"/>
                          <div className={styles.article}>
                            Для завершения регистрации, как самозанятого выполните<br/>
                            несколько шагов на сайте ФНС <a href="https://lknpd.nalog.ru">lknpd.nalog.ru</a>.
                          </div>
                          <div>
                            <div className={styles.screentitle}>
                              <span className={styles.screentitle_index}>1</span>
                              Выберите вход по номеру телефона и введите свой номер.
                              <img src={screenshot01} className={styles.screenshot} alt=''/>
                            </div>
                            <div className={styles.screentitle}>
                              <span className={styles.screentitle_index}>2</span>
                              Введите код активации, который вы получите по sms.
                              <img src={screenshot02} className={styles.screenshot} alt=''/>
                            </div>
                            <div className={styles.screentitle}>
                              <span className={styles.screentitle_index}>3</span>
                              В «Настройках» выберите «Партнеры» и подтвердите
                              запрос
                              {this.props.data?.items?.data?.partnerName?
                                  <React.Fragment>
                                    <br/>от {this.props.data.items.data.partnerName}.
                                  </React.Fragment> : null}
                              <img src={screenshot03} className={styles.screenshot} alt=''/>
                            </div>
                          </div>
                          <div className={styles.article}/>
                          <div className="l-align_right">
                            <ButtonCancel title="Проверить статус" onClick={this.handleReload}/>
                            <a href="https://lknpd.nalog.ru" className={styles.underline_none} style={{marginLeft: '1rem'}}>
                              <Button title="ПЕРЕЙТИ НА САЙТ ФНС"/>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <Footer/>
          </main>
        )
      }
    }
    else {
      return <PageLoading/>;
    }
  }
}

const mapStateToProps = state => ({data: state.clientInfo})

const mapDispatchToProps = dispatch => {
  return {fetchData: (url, parent, types) => dispatch(getInfoAction(url, parent, types))}
}

export default connect(mapStateToProps, mapDispatchToProps)(PageRequest);